import type { Messages } from '../messages.js'

/**
 * German. `Züge` for flips, because a `Drehung` is what the tile does and a `Zug` is what it
 * costs you, and the meter is a currency.
 */
export const de: Messages = {
  tag: 'de',

  readingDictionary: 'Wörterbuch wird gelesen…',
  noWordList: 'Keine Wortliste für „{language}“. Erzeuge sie:  pnpm dictionary build',
  emptyWordList: 'Die Wortliste für „{language}“ ist leer.',

  flips: 'Züge',
  score: 'Punkte',
  words: 'Wörter',
  round: 'Runde',
  ticksLeftLabel: 'Restzeit in dieser Runde',
  typeAWord: 'Wort eingeben',
  tapPrompt: 'antippen: nehmen oder zurückgeben, dann {action}',

  boardOfTiles: 'Feld mit {n} Steinen',
  faceDown: 'verdeckt',
  wildCard: 'Joker',
  wildKey: 'ein beliebiger Buchstabe',
  letterReplaced: 'Aus {from} wurde {to}',
  letterSwap: 'BUCHSTABENTAUSCH!',
  spentTile: 'verbrauchter Stein',
  hiddenWhilePaused: 'in der Pause verdeckt',
  letterInWord: '{letter}, Buchstabe {position} des Wortes',

  completeWord: 'Wort abgeben',
  completeShort: 'Abgeben',
  reset: 'Löschen',
  pause: 'Pause',
  resume: 'Weiter',
  newGame: 'Neues Spiel',
  paused: 'Pausiert',
  outOfFlips: 'Keine Züge mehr',
  finalResult: '{score} Punkte mit {words} in {rounds}',
  playAgain: 'Nochmal spielen',
  share: 'Teilen',
  shareCopied: 'Kopiert.',
  shareSelect: 'Das hier kopieren:',

  lettersSelect: 'Buchstaben wählen',
  keysWild: 'wird genommen, wenn du einen Buchstaben tippst, den kein Stein zeigt',
  clearsEvery: 'entfernt alle gewählten {letter}',
  undoLastLetter: 'letzten Buchstaben zurück',
  noWordsYet: 'Noch keine Wörter.',

  wordRejected: '{word}  {reason}',
  reasonDuplicate: 'schon gefunden',
  reasonTooShort: 'zu kurz',
  reasonNotAWord: 'kein Wort',
  reasonAllFound: 'die hast du alle schon',
  noSuchLetterUp: 'kein {letter} offen',
  nothingUp: 'nichts offen',
  letterHidden: 'ein Buchstabe hat sich versteckt',
  shuffled: 'gemischt',
  shuffledAndBilled: 'gemischt, {flips} unbenutzte Züge berechnet',
  tooFewLetters: 'Zu wenige Buchstaben übrig',

  gameLanguage: 'Sprache',
  interfaceLanguage: 'Oberfläche',
  dictionarySize: '{common} häufige von {full} Wörtern',
  filterLanguages: 'Sprachen suchen',
  noMatches: 'Keine Treffer',

  nerdMode: 'Expertenmodus',
  rules: 'Regeln',
  difficulty: 'Schwierigkeit',
  difficultyNames: { easy: 'leicht', medium: 'mittel', hard: 'schwer', insane: 'brutal' },
  pausedNoBoard: 'Dieses Spiel kommt nicht in die Rangliste.',
  about: 'Über',
  themeLabel: 'Darstellung',
  themeNames: { traditional: 'traditionell', light: 'hell', contrast: 'hoher Kontrast' },
  tiles: 'Steine (N)',
  secondsPerTick: 'Sekunden / Takt',
  holdTicks: 'Haltetakte',
  minWord: 'Mindestwort',
  startingFlips: 'Züge am Start',
  wildChance: 'Joker-Wahrscheinlichkeit',
  replaceChance: 'Wahrscheinlichkeit für Buchstabentausch',
  hideChance: 'Wahrscheinlichkeit für Buchstabenverstecken',
  wordCompleteMode: 'Wort fertig',
  wordCompleteNames: { shuffle: 'mischen', spend: 'verbrauchen', keep: 'behalten' },
  flipEconomy: 'Zugwirtschaft',
  flipEconomyNames: {
    none: 'keine',
    perLetter: 'pro Buchstabe',
    fibonacci: 'Fibonacci',
    overMinimum: 'über Minimum',
  },
  repeatedLetterKey: 'Taste bei Doppelbuchstaben',
  keySchemeNames: { cycle: 'durchlaufen', advance: 'weiterrücken' },
  keySchemeHelp: {
    cycle:
      'A nimmt das nächste freie A, und sobald alle im Wort sind, entfernt es sie. ' +
      'Umschalt+A entfernt sie ebenfalls.',
    advance: 'A nimmt das nächste freie A. Umschalt+A entfernt jedes A aus dem Wort.',
  },

  whatThatMeans: 'Was das bedeutet',
  factRound: 'eine Runde',
  factWholeBoardUp: 'ganzes Feld offen für',
  factRoundCosts: 'eine Runde kostet',
  factFlipsBuy: 'Startzüge reichen für',
  factThisBoard: 'dieses Feld',
  factBoardHadToAdmit: 'Feld musste zulassen',
  ticksAndSeconds: '{ticks}, {seconds}',
  wordsLongest: '{words}, längstes {longest}',
  wordsIncludingOneOf: '{words}, davon eins mit {ceiling}',
  scorelessRounds: '{rounds} ohne Punkte',

  whatAWordPays: 'Was ein Wort einbringt',
  columnLetters: 'Buchstaben',
  columnCost: 'Kosten',
  columnPoints: 'Punkte',
  columnFlips: 'Züge',
  columnNet: 'netto',

  canonicalRules: 'Reguläre Regeln für {difficulty}.',
  customRules: 'Von der Vorgabe abgewichen. Punkte mit eigenen Regeln werden nicht gewertet.',
  applyAndStart: 'Übernehmen und neu starten',
  changesNextGame: 'Änderungen gelten ab dem nächsten Spiel.',
  presets: 'Vorgaben:',

  start: 'Starten',
  restart: 'Neu starten',
  quit: 'Beenden',
  quitTitle: 'Dieses Spiel beenden?',
  restartTitle: 'Dieses Spiel neu starten?',
  restartConfirm: 'Neu starten',
  quitConfirm: 'Beenden',
  keepPlaying: 'Weiterspielen',
  personalBest: 'Deine besten Spiele',
  newPersonalBest: 'Neue persönliche Bestleistung.',
  columnRank: '#',
  notRanked: 'Eigene Regeln, daher wird dieses Spiel nicht gewertet.',
  notRankedPaused: 'Die Uhr ist stehengeblieben, daher wird dieses Spiel nicht gewertet.',
  rankOfTotal: '{rank} von {total}',

  howToPlay: 'Spielanleitung',

  backToGame: 'Zurück zum Spiel',
  welcomeTitle: 'Willkommen bei Blinkered',
  tutorialSkip: 'Überspringen',
  tutorialNext: 'Weiter',
  tutorialBack: 'Zurück',
  tutorialStart: 'Spiel starten',
  tutorialHideAgain: 'Nicht mehr anzeigen',
  tutorialProgress: '{n} von {total}',
  tutorialSkipTitle: 'Einführung überspringen?',
  tutGoalTitle: 'Blinkered ist ein Wettlauf',
  tutGoalBody:
    'Du beginnst das Spiel mit einer festen Zahl an Zügen, und jeder Stein, der sich dreht, kostet einen Zug. Sind die Züge aufgebraucht, ist das Spiel vorbei. Wörter bringen Züge, und je länger das Wort, desto mehr Züge bekommst du.',
  tutSpentBody:
    'Buchstaben, die du in einem Wort verwendest, liegen bis zur nächsten Runde verdeckt. Nur ein Buchstabenwechsel ändert, welche Buchstaben auf dem Feld liegen.',
  tutChangeTitle: 'Buchstaben können sich ändern',
  tutSameLetters:
    'Ein Wort entdeckt, das du nicht mehr spielen konntest? Dieselben Buchstaben kommen in der nächsten Runde wieder, an neue Stellen gemischt.',
  tutPickLetters: 'Tippe die Buchstaben, die du willst, der Reihe nach an, um ein Wort zu bilden.',
  tutMoreTurn:
    'Während Sie überlegen, drehen sich weitere Plättchen um: ein besserer Buchstabe kann noch kommen.',
  tutTapBack:
    'Versehentlich einen genommen? Tippen Sie ihn noch einmal an, um ihn zurückzugeben. Jeden, nicht nur den letzten.',
  tutComplete: 'Drücken Sie Fertig, wenn das Wort steht.',
  htBoardTitle: 'Das Feld',
  htBoardBody:
    'Die Steine werden einzeln umgedreht, in zufälliger Reihenfolge. Aus den offenen Steinen bildest du Wörter.',
  htWordsTitle: 'Die Wörter',
  htWordsBody:
    'Bilde ein Wort aus den offenen Steinen, indem du die Buchstaben der Reihe nach tippst oder anklickst.',
  htFlipsTitle: 'Die Züge',
  htFlipsBody:
    'Jeder Stein, der sich dreht, kostet einen Zug. Ein fertiges Wort schreibt Züge wieder gut, und lange Wörter geben mehr. Sind die Züge aufgebraucht, ist das Spiel vorbei.',
  htRoundTitle: 'Die Runde',
  htRoundBody:
    'Dreht sich der letzte Stein einer Runde, liegt das ganze Feld einen Moment offen. Dann werden die Steine umgedreht und gemischt, und eine neue Runde beginnt.',
  htLanguagesTitle: 'Die Sprachen',
  htLanguagesBody:
    '{n}. Jedes Feld lässt sich mit gebräuchlichen Wörtern lösen. Ein seltenes Wort zählt trotzdem, wenn das Wörterbuch es kennt.',
  htKeysTitle: 'Die Tastatur',
  htWildTitle: 'Joker',
  htWildBody:
    'Manchmal erscheint ein Joker statt eines Buchstabens. Ein Joker gilt als jeder Buchstabe, der ein gültiges Wort ergibt. Ein bereits gefundenes Wort zählt nicht.',
  htHideTitle: 'Buchstaben, die sich verstecken',
  htHideBody:
    'In den schwereren Stufen kann ein offener Buchstabe sich von selbst wieder umdrehen und später in der Runde zurückkommen. Die Anzeige bekommt dafür einen zusätzlichen Takt, in Rot. Schon genommene Buchstaben drehen sich nicht um.',
  tutHideBody:
    'In den schwereren Stufen kann ein offener Buchstabe sich von selbst wieder umdrehen und später in der Runde zurückkommen. Schon genommene Buchstaben drehen sich nicht um.',
  htSwapTitle: 'Wechselnde Buchstaben',
  htSwapBody:
    'Manchmal wird zwischen den Runden ein Buchstabe durch einen anderen ersetzt. Du siehst, welcher Buchstabe weg ist und welcher dazugekommen ist.',
  htLevelsTitle: 'Die Stufen',
  htLevelEasy:
    'Dieselben zwölf Buchstaben die ganze Partie über: du kannst sie dir einprägen und eine Wortliste im Kopf behalten. Die Steine drehen sich langsam, und das volle Feld bleibt lange genug sichtbar, um deine Buchstaben in Ruhe auszuwählen.',
  htLevelMedium:
    'Ab und zu wechselt ein Buchstabe, und dann wird es schwerer, sich Wörter zu merken, die du später spielen wolltest. Weniger Zeit zum Schauen und weniger zum Nachdenken.',
  htLevelHard:
    'Wörter mit drei Buchstaben zählen nicht mehr, und etwa jede zweite Runde wechselt ein Buchstabe. Das Feld ist kaum zu sehen, bevor neu gemischt wird.',
  htLevelInsane:
    'Alles auf einmal, in vollem Tempo. Das Feld wird fast unmittelbar nach dem letzten Zug gemischt.',
  htTouchTitle: 'Der Berührungsbildschirm',
  htTouchBody:
    'Tippe ein aufgedecktes Plättchen an, um seinen Buchstaben zu nehmen. Tippe einen genommenen Buchstaben an, um ihn zurückzugeben. Abgeben und Löschen liegen unter dem Brett.',

  accountTitle: 'Dein Konto',
  menuProfile: 'Mein Profil',
  menuGames: 'Meine Spiele',
  menuPublicPage: 'Meine öffentliche Seite',
  menuSignedInAs: 'Angemeldet als',
  signIn: 'Anmelden',
  signOut: 'Abmelden',
  signInTitle: 'Anmelden oder registrieren',
  signInLead: 'Ein Konto bewahrt deine Spiele auf, auf jedem Gerät.',
  signInKeepGame: 'Melde dich an, um dieses Spiel zu behalten, und jedes danach.',
  continueWithApple: 'Mit Apple fortfahren',
  continueWithGoogle: 'Mit Google fortfahren',
  signInOr: 'oder',
  emailLabel: 'E-Mail',
  codeLabel: 'Code',
  emailMeACode: 'Schick mir einen Code',
  working: 'Einen Moment…',
  sendNewCode: 'Neuen Code senden',
  codeSent: 'Sieh in dein Postfach. Der Code gilt 10 Minuten.',
  notNow: 'Jetzt nicht',
  badEmail: 'Das sieht nicht nach einer E-Mail-Adresse aus.',
  badCode:
    'Dieser Code hat nicht funktioniert. Codes laufen nach 10 Minuten ab und gelten nur einmal.',
  serverBusy: 'Server nicht erreichbar. Versuch es gleich noch einmal.',
  serverDown: 'Server nicht erreichbar.',
  offline: 'Offline',
  leaderboardTitle: 'Rangliste',
  leaderboardEmpty: 'Noch keine Spiele auf dieser Rangliste. Sei der Erste.',
  leaderboardWouldBe: 'Wo dieses Spiel stehen würde',
  leaderboardThisGame: 'Dieses Spiel',
  leaderboardRanksHere: 'Wo dieses Spiel steht',
  leaderboardOutside: 'Außerhalb der besten fünf.',
  tutAccountTitle: 'Punkte behalten',
  tutAccountBody:
    'Ein Konto speichert deine Spiele, setzt deine Punkte auf die Rangliste und verwaltet dein Profil.',
  ssoCancelled: 'Anmeldung abgebrochen.',
  ssoExpired: 'Das hat zu lange gedauert. Melde dich noch einmal an.',
  ssoNoUsername: 'Konto konnte nicht fertig angelegt werden. Versuch es gleich noch einmal.',
  ssoFailed: 'Das hat nicht geklappt. Versuch es noch einmal oder nimm deine E-Mail.',
  tabProfile: 'Profil',
  countryAny: 'Keine Angabe',
  findCountry: 'Länder suchen',
  usernameLabel: 'Benutzername',
  bioLabel: 'Über mich',
  countryLabel: 'Land',
  bioHint: 'Keine Links. {left}/{max}',
  save: 'Speichern',
  saving: 'Wird gespeichert…',
  saved: 'Gespeichert.',
  nameTaken: 'Diesen Namen hat schon jemand.',
  nameTooShort: 'Etwas länger, bitte.',
  nameTooLong: 'Das ist zu lang.',
  nameBadCharacters: 'Nur Buchstaben, Ziffern, Bindestriche und Unterstriche.',
  nameBadEdges: 'Er muss mit einem Buchstaben oder einer Ziffer beginnen und enden.',
  nameMixedScripts: 'Nimm ein Alphabet und bleib dabei.',
  nameReserved: 'Das sieht nach einem Namen aus, den wir selbst vergeben. Wähl einen anderen.',
  nameUnusable: 'Dieser Name ist nicht verwendbar.',
  bioTooLong: 'Über mich fasst höchstens {max} Zeichen.',
  bioHasLink: 'Links sind hier nicht erlaubt.',
  bioHasControl: 'Das enthält Zeichen, die hier nicht stehen können.',
  bioUnusable: 'Dieser Text ist nicht verwendbar.',
  gamesHeading: 'Spiele',
  gamesEmpty: 'Noch nichts hier. Spiele, die du angemeldet spielst, erscheinen hier.',
  gamesEmptyShort: 'Noch nichts hier.',
  gamesLoading: 'Deine Spiele werden gelesen…',
  theirGamesLoading: 'Ihre Spiele werden gelesen…',
  profileLoading: 'Profil wird gelesen…',
  playerNotFound: 'Hier ist niemand mit diesem Namen.',
  columnWhen: 'Wann',
  columnRounds: 'Runden',
  columnGame: 'Spiel',
  gameLoading: 'Spiel wird gelesen…',
  gameUnreadable: 'Dieses Spiel konnte nicht gelesen werden.',
  gameNotRanked: 'Mit geänderten Regeln gespielt, daher nicht gewertet.',
  detailNotKept: 'Wörter und Felder dieses Spiels werden nicht mehr aufbewahrt.',
  openingBoard: 'Das Startfeld',
  roundByRound: 'Runde für Runde',
  roundNothing: 'nichts gefunden',
  changeReplaced: '{letter} ersetzt auf Platz {slot}',
  changeWildOn: '{letter} Joker auf Platz {slot}',
  changeWildOff: '{letter} Joker weg von Platz {slot}',
  keepThisGame: 'Dieses Spiel behalten',
  savedToYourGames: 'Zu deinen Spielen gespeichert.',

  reportThis: 'Melden',
  reportHeading: 'Das hier melden',
  reportTheName: 'Der Name',
  reportTheBio: 'Der Text',
  reportTheScore: 'Die Punktzahl',
  reportWhy: 'Was ist daran falsch? Optional.',
  reportSend: 'Meldung senden',
  reportSent: 'Danke. Jemand sieht sich das an.',
  reportSignIn: 'Melde dich an, um etwas zu melden.',
  reportGone: 'Das ist nicht mehr da.',
  reportCancel: 'Abbrechen',

  deleteAccount: 'Mein Konto löschen',
  deleteAccountWhat:
    'Das entfernt dein Profil und jedes gespeicherte Spiel, endgültig. Es lässt sich nicht zurücknehmen.',
  deleteAccountAsk: 'Schick mir einen Code',
  deleteConfirm: 'Endgültig löschen',
  deleteGone: 'Dein Konto ist weg. Danke fürs Spielen.',
  deleteNoAddress:
    'Für dieses Konto gibt es keine bestätigte Adresse, also kann eine Löschung nicht geprüft werden. Melde dich, dann machen wir es von Hand.',

  rulesetFacts: 'Wörter ab {letters} · alle {seconds} ein neuer Stein',
  plurals: {
    words: { one: '{n} Wort', other: '{n} Wörter' },
    rounds: { one: '{n} Runde', other: '{n} Runden' },
    flips: { one: '{n} Zug', other: '{n} Züge' },
    ticks: { one: '{n} Takt', other: '{n} Takte' },
    points: { one: '{n} Punkt', other: '{n} Punkte' },
    minLetters: { one: '{n} Buchstaben', other: '{n} Buchstaben' },
    seconds: { one: '{n} Sekunde', other: '{n} Sekunden' },
  },
}
